import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import packageJson, { homepage as routerBase } from '../package.json';
import './App.less';
import Routes from './Routes';
import { settings } from './settings';
import ThemeContext from './store/ThemeContext';

const theme = packageJson.config?.preid
  ? {
      ...settings.preference.default,
      ...settings.preference[packageJson.config.preid],
    }
  : settings.preference.default;

function App() {
  return (
    <BrowserRouter basename={routerBase}>
      <ThemeContext.Provider value={theme}>
        <Routes />
      </ThemeContext.Provider>
    </BrowserRouter>
  );
}

export default App;
